import { render, staticRenderFns } from "./ChatPreview.vue?vue&type=template&id=70e5fb84&scoped=true&"
import script from "./ChatPreview.vue?vue&type=script&lang=js&"
export * from "./ChatPreview.vue?vue&type=script&lang=js&"
import style0 from "./ChatPreview.vue?vue&type=style&index=0&id=70e5fb84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e5fb84",
  null
  
)

export default component.exports